import * as React from 'react';
import MultipleFiles from '../../MultipleFiles';
import type { CreatorProps } from '../types';

interface Props extends CreatorProps {
  schemaProps: {
    title: { ru: string; en: string };
    id: string;
    value: any;
    disabled: boolean;
    activeDeleteBtn?: boolean;
    someProperties?: Record<string, any>;
    extra?: Record<string, any>;
  };
}

export const FileInput = ({ schemaProps, ...props }: Props) => {
  const { schema, api, dispatcher, error } = props;
  return (
    <MultipleFiles
      schema={{
        ...schema,
        ...schemaProps,
      }}
      api={api}
      dispatcher={dispatcher}
      error={error}
    />
  );
};
